// React/finance-app/src/features/tt-insights/tabs/UserBalanceTab.jsx
import React from 'react';
import { money } from '../utils';
import ExportButton from '../ExportButton';

const UserBalanceTab = ({
  loading,
  fetchUserBalance,
  userCode,
  setUserCode,
  userBalance,
}) => (
  <div className="card">
    <div className="card-header">User Balance</div>
    <div className="card-body">
      <div className="row g-2 align-items-end mb-3">
        <div className="col-md-3">
          <label className="form-label">User Code</label>
          <input
            type="text"
            className="form-control form-control-sm"
            value={userCode}
            onChange={(e) => setUserCode(e.target.value)}
            placeholder="Enter user code…"
          />
        </div>
        <div className="col-md-2">
          <button
            className="btn btn-primary btn-sm w-100"
            onClick={() => fetchUserBalance(userCode)}
            disabled={!userCode.trim() || loading}
          >
            {loading ? 'Loading…' : 'Get Balance'}
          </button>
        </div>
      </div>

      {userBalance ? (
        <div className="table-responsive">
          <div className="mb-2 d-flex justify-content-end">
            <ExportButton
              disabled={!userBalance}
              filenameBase={`user-balance_${userBalance.user_code}`}
              sheetName="User Balance"
              columns={[
                { key: "label", header: "Field" },
                { key: "value", header: "Value" },
              ]}
              rows={[
                { label: "User Code", value: userBalance.user_code },
                { label: "Paid Referral", value: money(userBalance.paid_referral) },
                { label: "Paid Trust", value: money(userBalance.paid_trust) },
                { label: "Paid Deposit", value: money(userBalance.paid_deposit) },
                { label: "Total Paid", value: money(userBalance.total_paid) },
                { label: "Charges & Credits", value: money(userBalance.charges_and_credits) },
                { label: "Withdrawn", value: money(userBalance.withdrawn_filtered) },
                { label: "Expired (Trust)", value: money(userBalance.expired_deduction) },
                { label: "Expired (Referral)", value: money(userBalance.expired_referral_deduction) },
                { label: "Available", value: userBalance.formatted_balance ?? money(userBalance.available_balance) },
                { label: "Status", value: userBalance.balance_status },
              ]}
            />
          </div>
          <table className="table table-sm table-bordered table-striped w-auto">
            <tbody>
              <tr><th>User Code</th><td>{userBalance.user_code}</td></tr>
              <tr><th>Paid Referral</th><td>{money(userBalance.paid_referral)}</td></tr>
              <tr><th>Paid Trust</th><td>{money(userBalance.paid_trust)}</td></tr>
              <tr><th>Paid Deposit</th><td>{money(userBalance.paid_deposit)}</td></tr>
              <tr><th>Total Paid</th><td>{money(userBalance.total_paid)}</td></tr>
              <tr><th>Charges & Credits</th><td>{money(userBalance.charges_and_credits)}</td></tr>
              <tr><th>Withdrawn</th><td>{money(userBalance.withdrawn_filtered)}</td></tr>
              <tr><th>Expired (Trust)</th><td>{money(userBalance.expired_deduction)}</td></tr>
              <tr><th>Expired (Referral)</th><td>{money(userBalance.expired_referral_deduction)}</td></tr>
              <tr><th>Available</th><td>{userBalance.formatted_balance ?? money(userBalance.available_balance)}</td></tr>
              <tr><th>Status</th><td>{userBalance.balance_status}</td></tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-muted">Enter a user code and click “Get Balance”.</div>
      )}
    </div>
  </div>
);

export default UserBalanceTab;
